import { HeroBanner } from '@purpur/library';
import styled, { css } from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';
import { NAVIGATION_OFFSET_CSS_VARIABLE } from '@telialt/utils/src/NavigationUtils/constants';

type ContainerProps = {
    $hasControls?: boolean;
};

export const BlockHeroBannerContainer = styled.div<ContainerProps>`
    scroll-margin-top: var(${NAVIGATION_OFFSET_CSS_VARIABLE});
    ${({ $hasControls }) =>
        $hasControls &&
        css`
            margin-bottom: ${getPurpurSpacing('250')};
            ${purpurMedia('lg')`
                margin-bottom: ${getPurpurSpacing('200')};
            `};
        `};
`;

export const StyledHeroBanner = styled(HeroBanner)`
    [class^='_purpur-hero-banner__breadcrumbs'] {
        overflow: hidden;
    }
    [class^='_purpur-hero-banner__breadcrumbs']:empty {
        padding: 0;
    }
`;
